// Apps Error messages

export const apps = {
    nameEmpty : "App Name cannot be empty.",
    appNameLength : "App name must be at least 5 characters",
    pipeEmpty : "Pipe Name cannot be empty.",
    appSuccess: "App created successfully!",
    notConfigured: "Not yet configured",
    selectAppTypes: "Please select atleast one app type",
    appWarning: "Special characters are not allowed in the app name; only A-Za-z0-9, underscores (_), and hyphens (-) are accepted.",
    appConfigure: "Apps configured successfully",
    appReConfigure: "Apps Re-configured successfully",
    failedDownload: "App download Failed",
    asyncMode: "Asynchronous mode of OpenAI or Azure OpenAI client.",
    embedModel: "Embedding model name, supported models openai, azure-openai, mistral, llama 3.1. ",
    vectorStore: "Configuration for the vector store. Default is Chroma db",
    dbPath:"Path to the history database. Default Sqlite memory",
    tools: "List of handler method names (as dictionaries or strings) available for use during interactions. Defaults to None. If nothing provide Engine will get it dynamically using dir(handler).",
    output: "An optional parser to format and process the handler tools output.",
    emptyEngine: "Please select atleast one engine",
    emptyAgent: "Please select atleast one agent",
    unsavedChanges: "You have unsaved changes please save or reset the changes"
}

export const cloud = {
    appNameSpecial : "Special characters are not allowed.",
    accessKeyEmpty: "Access Key Cannot be empty",
    secretKeyEmpty: "Secret Key Cannot be empty",
    serviceErrror: "Please select atleast one service",
    subcriptionEmpty: "Subscription id cannot be empty",
    clientEmpty: "Client id cannot be empty",
    tenantEmpty: "Tenant id cannot be empty"

}

export const user = {
    nameEmpty : "User Name cannot be empty.",
    userNameLength : "User name must be at least 5 characters",
    specialChar: "Special characters are not allowed in the name.",
    emailEmpty : "Please Enter Email Id",
    invalidemail:"Email is not valid!",
    roleEmpty:"Please Select a Role",
    userSuccess: "User created successfully!",
    htmlTags: "HTML tags are not allowed in the name."
}

export const extract = {
    savesuccess : "Save Successfully",
    savefailed : "Failed To Save"
}

export const cluster = {
    deployNotify : "Review your configuration before creating. Your cluster will be provisioned immediately after submission.",
    networkInfo : "To set the VPC ID and Subnet ID, click 'Additional Information' to proceed to the next step. Otherwise, click 'Create Cluster' to continue.",
    descriptionInfo : "Adding a description helps yout team understand the cluster's purpose.",
    selectCluster: "Please select a cluster",
    domainEmpty: "Domain name cannot be empty",
    domainInvalid: "Enter a valid domain, for example *.app-dev-3.test.ai",
    certEmpty: "Certificate cannot be empty",
    certInvalid: "Enter a valid certificate ARN",
    configSaved: "Workload created",
    configSaveFailed: "Failed to create workload",
    configLoadFailed: "Failed to load cluster configuration",
}

export const messages = {
    characterLimit : "Prompt must be at least %s characters long",
    otpSentMessage : "OTP sent to your Registered Email Address",
    otpResentMessage : "OTP has been resent to your email"
}

export const errorMessage = {
    sessionExpired : "Your session has expired or you don\'t have permission to access this resource.",
    unexpectedError : "An unexpected error occurred"
}